import type { ReactNode } from "react";

import { ConnectionFlowsConfigContext, type ConnectionFlowsConfig } from "./config";

export function ConnectionFlowsProvider({ config, children }: { config: ConnectionFlowsConfig; children: ReactNode }) {
  return <ConnectionFlowsConfigContext.Provider value={config}>{children}</ConnectionFlowsConfigContext.Provider>;
}
